import clsx from 'clsx'

import styles from './IconButton.module.scss'

export interface IconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactElement | string
  variant?: 'green' | 'gray' | 'transparent'
  size?: 'superSmall' | 'small' | 'medium' | 'large'
  disabled?: boolean
  icon?: React.ReactElement
  ref?: React.RefObject<HTMLButtonElement | null>
}

// Anything other than gray/transparent (incl. no variant) renders green
const getVariantClass = (variant: IconButtonProps['variant']) => {
  switch (variant) {
    case 'gray':
      return styles.gray
    case 'transparent':
      return styles.transparent
    default:
      return styles.green
  }
}

const IconButton = (props: IconButtonProps) => {
  const {
    onClick,
    children,
    variant,
    size,
    disabled,
    icon,
    ref,
    className,
    ...rest
  } = props

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onClick && onClick(e)
  }

  return (
    <button
      data-size={size}
      disabled={disabled}
      onClick={handleClick}
      {...rest}
      ref={ref}
      className={clsx(styles.iconButton, getVariantClass(variant), className)}
    >
      <span>{children || icon}</span>
    </button>
  )
}

export default IconButton
